<template>
  <v-app-bar
    app
    color="white"
    :class="[{ 'px-8': !$vuetify.breakpoint.smAndDown }]"
    :elevate-on-scroll="$route.name
      && !$route.name.includes('projects-administration') && !$route.name.includes('app-setting')"
    clipped-left
    clipped-right
  >
    <router-link :to="{ name: 'home' }" v-if="$route.name === 'home'">
      <v-img
        :max-height="$vuetify.breakpoint.smAndDown ? 35 : 45"
        :max-width="$vuetify.breakpoint.smAndDown ? 70 : 200"
        position="left"
        contain
        :alt="logo.alt"
        :src="$vuetify.breakpoint.smAndDown ? logo.src.xs : logo.src.normal"
      >
      </v-img>
    </router-link>
    <v-app-bar-nav-icon
      @click="openApplicationList(true)"
      v-if="$route.name !== 'home'"
      color="secondary"
      class="mr-2"
    >
    </v-app-bar-nav-icon>
    <div v-if="$route.name !== 'home'" class="d-flex justify-center align-center">
      <router-link :to="{ name: 'home' }">
        <v-img
          :max-height="$vuetify.breakpoint.smAndDown ? 35 : 45"
          :max-width="$vuetify.breakpoint.smAndDown ? 70 : 90"
          position="left"
          contain
          :alt="logo.alt"
          :src="logo.src.xs"
        ></v-img>
      </router-link>
      <v-toolbar-title
        :class="[
          { 'subtitle-1': $vuetify.breakpoint.smAndDown },
          'secondary--text',
          'font-weight-bold',
          'pl-1',
        ]"
        style="position:relative; left:-30px"
      >
        {{ titleUpperCase }}
      </v-toolbar-title>
    </div>
    <v-spacer></v-spacer>
    <v-btn
      text
      class="mr-2"
      color="primary"
      @click="setDialogShowHelp(true)"
    >
      <v-icon class="mr-2">mdi-help-circle</v-icon>
      Help
    </v-btn>
    <v-menu
      nudge-top="-10"
      offset-y
      elevation="0"
      style="boxShadow: 0px 6px 35px rgba(0, 0, 0, 0.2) !important;"
    >
      <template v-slot:activator="{ on }">
        <div
          v-on="on"
          class="pointer"
        >
          <v-avatar
            :size="$vuetify.breakpoint.smAndDown ? 35 : 45"
            color="primary"
          >
            <v-img
              v-if="profile.image_url && !profile.image_url.includes('/user_X')"
              contain
              :src="profile.image_url"
              :alt="profile.fullName"
            ></v-img>
            <span v-else class="white--text body-1 font-weight-bold">
              {{ getInitials(profile.firstName, profile.lastName) }}
            </span>
          </v-avatar>
          <strong
            class="subtitle-1 font-weight-bold ml-4 d-none d-sm-inline secondary--text"
            v-html="profile.fullName"
          ></strong>
          <v-btn small icon color="secondary" class="d-none d-sm-inline ml-1">
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </div>
      </template>

      <v-card elevation="3">
        <v-list>
          <v-list-item>
            <v-list-item-avatar color="primary" class="d-flex justify-center">
              <v-img
                v-if="profile.image_url && !profile.image_url.includes('/user_X')"
                contain
                :src="profile.image_url"
                :alt="profile.fullName"
              ></v-img>
              <span v-else class="white--text body-2 font-weight-light">
                {{ getInitials(profile.firstName, profile.lastName) }}
              </span>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>
                {{ profile.fullName }}
                </v-list-item-title>
              <v-list-item-subtitle>{{ profile.emailId }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-item :to="{ name: 'signout' }">
            <v-list-item-title>Sign out</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
/* eslint-disable max-len */

import { mapMutations } from 'vuex';

import urlLogoNormal from '@/assets/logo.png';
import urlLogoXs from '@/assets/logo-xs.png';

export default {
  props: ['profile'],
  data() {
    return {
      logo: {
        alt: 'Axoscape',
        src: {
          normal: urlLogoNormal,
          xs: urlLogoXs,
        },
      },
    };
  },
  computed: {
    titleUpperCase() {
      return this.$route.name ? this.$route.name.split(' ')[0].replaceAll('-', ' ').toUpperCase() : '';
    },
  },
  methods: {
    ...mapMutations(['openApplicationList', 'setDialogShowHelp']),
    getInitials(firstName, LastName) {
      return `${firstName.length ? firstName[0].toUpperCase() : ''}${LastName.length ? LastName[0].toUpperCase() : ''}`;
    },
  },
};
</script>

<style>
  .v-sheet.theme--light.v-toolbar.v-app-bar.v-app-bar--clipped.v-app-bar--elevate-on-scroll.v-app-bar--fixed.v-app-bar--is-scrolled {
    box-shadow: 0px 6px 35px rgba(0, 0, 0, 0.2) !important;
  }

  .v-sheet.theme--light.v-toolbar.v-app-bar.v-app-bar--clipped.v-app-bar--fixed {
    box-shadow: 0px 6px 35px rgba(0, 0, 0, 0.2);
  }
</style>
